import React, {PureComponent} from 'react';
import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';
import LazyLoad from '../lazy-load/LazyLoad';
import {LAZY_LOAD_OFFSET} from '../../../utils/constants';
import PlaceholderImage from './Placeholder';

export class RatioCard extends PureComponent {
    render() {
        const {
            altText,
            aspectRatio = '3x4',
            footer,
            getImageUrl,
            isMobile,
            linkRel,
            onClick,
            path,
            title,
        } = this.props;

        const link = {
            href: path,
            rel: linkRel,
        };

        const imageUri = getImageUrl('xs');
        const offset = LAZY_LOAD_OFFSET[isMobile ? 'MOBILE' : 'DEFAULT'];

        const cardComponent = (
            <a {...link} onClick={onClick} className="RatioCard" title={title}>
                <AspectRatioCard aspectRatio={aspectRatio} key={imageUri}>
                    <div
                        data-slot={'figure'}
                        className="RatioCard__img-container"
                    >
                        <LazyLoad
                            offset={offset}
                            placeholder={<PlaceholderImage />}
                        >
                            <img src={imageUri} alt={altText} />
                        </LazyLoad>
                    </div>
                    {(title || footer) && (
                        <div
                            data-slot={'content'}
                            className="RatioCard__content"
                        >
                            {title && <h4>{title}</h4>}
                            {footer && <div>{footer}</div>}
                        </div>
                    )}
                </AspectRatioCard>
            </a>
        );

        return cardComponent;
    }
}
